<template>
  <div class="home-wrap">
    <van-loading type="spinner" vertical>
      <div>正在加载中...</div>
    </van-loading>
  </div>
</template>

<script>
import Api from '@/api'

export default {
  data() {
    return {}
  },
  created() {
    // window.wx.miniProgram.postMessage({
    //   data: {
    //     type: 'faceType',
    //     userId: '11111',
    //     userInfo: '11111',
    //   },
    // })
    // setTimeout(() => {
    //   window.wx.miniProgram.navigateBack()
    //   // this.$router.back()
    // }, 3500);
  },
  
}
</script>
<style lang="less" scoped>
.home-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
